import { accountingSystemProvider } from 'shared';

import { useGetSelectedOrganisation } from './useGetSelectedOrganisation';

export function useAccountingSystemName() {
  const organisation = useGetSelectedOrganisation();

  return accountingSystemProvider(organisation)?.displayName ?? ``;
}
